module.exports = __webpack_public_path__ + "img/bx-change-timetable.ab727707.svg";